import {
  ResultType,
  StorageBiomarker,
  LaboratoryResultDetail,
  OrderingProvider,
  HealthCase,
} from '@/api/__generated__/webApi';
import { ISODate } from '@/types';

export type {
  Product,
  Test,
  Panel,
  LaboratoryResultDetail,
} from '@/api/__generated__/webApi';

export interface ManualResultDetail {
  /** @format date */
  date?: string;
  /** @format uuid */
  id: string;
  name?: string;
  description?: string;
  recognition: boolean;
  storageBiomarkers?: StorageBiomarker[];
  hasFile: boolean;
  type: ResultType;
  healthCases?: HealthCase[];
}

export type ResultDetail = LaboratoryResultDetail;

export interface Patient {
  birthDate: string;
  birthSex: BirthSex;
  firstName: string;
  lastName: string;
  middleName: string;
}

export interface OrderDetails {
  collected: ISODate;
  number: number;
  provider: OrderingProvider;
  reported: ISODate;
}

export interface Reference {
  isOutOfRef: boolean;
  maxValue?: number | null;
  minValue?: number | null;
}

interface QualityReference {
  isOutOfRef: boolean;
  value?: string | null;
}

export enum DynamicResultType {
  All = 'ALL',
  Laboratory = 'LABORATORY',
  Manual = 'MANUAL',
}

export interface DynamicsResult {
  comment: string;
  criticalReference: Reference;
  dateTime: string;
  qualityReference: QualityReference | null;
  reference: Reference;
  value?: string | null;
  type?: DynamicResultType.Manual | DynamicResultType.Laboratory;
  labTestCode?: string;
  labTestName?: string;
}

export interface DynamicsTest {
  code: string;
  unit?: string;
  name?: string;
  results: DynamicsResult[];
}

export interface ResultsSearch {
  contentType: string;
  data: string;
  error: string;
  fieldErrors: [
    {
      error: string;
      field: string;
    },
  ];
  expiredSeconds: number;
  attemptsLeft: number;
  message: string;
}

enum BirthSex {
  Male = 'MALE',
  Female = 'FEMALE',
  Unknown = 'UNKNOWN',
}

export type FlagType = 'NORMAL' | 'ABNORMAL' | 'CRITICAL';
